const SERVICE_URL_GTICKET = process.env.REACT_APP_API_G_TICKET + "/api/";
const SERVICE_URL_G_TICKET_V2 = process.env.REACT_APP_API_G_TICKET_V2 + "/api/";
const WsCode = {
  workGroups: "work-groups",
  categories: "categories/get-list",
};

export { SERVICE_URL_GTICKET, SERVICE_URL_G_TICKET_V2, WsCode };
